import { Type } from '@angular/core';

export const componentUrls = new Map<Type<Object>, string>();
export const urlComponents = new Map<string, Type<Object>>();
export const componentUrlProperties = new Map<Object, string[]>();
export const componentUrlQueries = new Map<Object, string>();
export const componentTitleProperties = new Map<Object, { propertyName: string, translate: boolean; }>();
